import { Link } from 'react-router-dom'

import BarLineChart from '@Icons/bar-line-chart.svg?react'
import Competitors from '@Icons/competitors-icon.svg?react'
import Products from '@Icons/products.svg?react'
import Refresh from '@Icons/refresh.svg?react'

function ProductsEmpty(): JSX.Element {
  return (
    <div className="flex flex-col items-center text-center mt-16 px-4">
      <div className="flex items-center justify-center w-14 h-14 rounded-full bg-primary-50 mb-5">
        <Products className="w-7 h-7" />
      </div>

      <h2 className="font-medium text-xl text-gray-900 mb-2">
        Add your first products
      </h2>
      <p className="text-sm text-gray-500 max-w-md mb-6 leading-relaxed">
        Import your catalog to start tracking competitor prices and get
        repricing suggestions.
      </p>

      <Link to="/data-management/products">
        <div className="inline-flex items-center justify-center bg-primary-600 hover:bg-primary-700 text-white font-medium text-sm rounded-lg px-5 py-2.5">
          Add products
        </div>
      </Link>

      <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 mt-8">
        <span className="flex items-center gap-2 text-xs text-gray-500">
          <Competitors className="w-4 h-4" />
          Track competitor prices
        </span>
        <span className="flex items-center gap-2 text-xs text-gray-500">
          <Refresh className="w-4 h-4" />
          Repricing suggestions
        </span>
        <span className="flex items-center gap-2 text-xs text-gray-500">
          <BarLineChart className="w-4 h-4" />
          Price and position insights
        </span>
      </div>
    </div>
  )
}

export default ProductsEmpty
